import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-8 pl-8 draglist" }
const _hoisted_2 = { class: "item" }
const _hoisted_3 = ["onDragstart"]
const _hoisted_4 = ["onDrop"]
const _hoisted_5 = { class: "pl-8" }
const _hoisted_6 = ["onDragstart"]
const _hoisted_7 = { key: 0 }

import { Co2QuizQuestion } from '@/models/co2-quiz.model';
import { PropType, ref } from 'vue';
import { useStore } from 'vuex';
import { ShiftCMSState } from '@/store';
import {
  Co2QuizStoreActions,
  Co2QuizStoreState,
} from '@/stores/co2-quiz.store';
import SortItems from '@/components/common/SortItems.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Co2QuestionsSortingForm',
  props: {
  data: {
    type: Array as PropType<Co2QuizQuestion[]>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const store = useStore<ShiftCMSState & { co2: Co2QuizStoreState }>();

const drag = ref<boolean>(false);
const dragItem = ref<Co2QuizQuestion | null>(null);

const dragStart = (e: Event, el: Co2QuizQuestion) => {
  drag.value = true;
  dragItem.value = el;

  return null;
};

const dragEnd = () => {
  drag.value = false;
  return null;
};

const dragDrop = async (evt: DragEvent, el: Co2QuizQuestion | null) => {
  evt.preventDefault();
  drag.value = false;

  await store.dispatch(Co2QuizStoreActions.UpdateCo2QuizQuestion, {
    ...dragItem.value,
    parentQuestion: el,
  });

  await store.dispatch(Co2QuizStoreActions.GetCo2Questions);

  dragItem.value = null;
};

const dragOver = (evt: DragEvent) => {
  evt.preventDefault();

  if (evt.target) {
    (evt.target as Element).classList.add('drag-active');
  }
};
const dragLeave = (evt: DragEvent) => {
  evt.preventDefault();
  if (evt.target) {
    (evt.target as Element).classList.remove('drag-active');
  }
};

const save = (v: number[]) => {
  store.dispatch(Co2QuizStoreActions.UpdateQuestionOrder, v);
};

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[7] || (_cache[7] = _createElementVNode("h2", null, "Edit co2 question hierarchy", -1)),
      _createVNode(_component_v_alert, { type: "info" }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode(" Drag the co2 question onto their parent. This is allowed only for "),
          _createElementVNode("i", null, "one level", -1),
          _createTextVNode(". ")
        ])),
        _: 1
      }),
      _createVNode(_component_v_card, { class: "mt-4 pb-4" }, {
        default: _withCtx(() => [
          _createElementVNode("ul", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data
            .filter((c) => !c.parentQuestion)
            .sort((a, b) => a.index - b.index), (cat) => {
              return (_openBlock(), _createElementBlock("li", {
                key: cat.id
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", {
                    class: "name",
                    draggable: "true",
                    onDragstart: (e) => dragStart(e, cat),
                    onDragend: dragEnd
                  }, _toDisplayString(cat.title), 41, _hoisted_3),
                  (drag.value && dragItem.value?.id !== cat.id)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "drop-target",
                        onDrop: (e) => dragDrop(e, cat),
                        onDragover: _cache[0] || (_cache[0] = (e) => dragOver(e)),
                        onDragleave: _cache[1] || (_cache[1] = (e) => dragLeave(e))
                      }, null, 40, _hoisted_4))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("ul", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data
                .filter((c) => c.parentQuestion?.id === cat.id)
                .sort((a, b) => a.index - b.index), (cat2) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: cat2.id
                    }, [
                      _createElementVNode("div", {
                        draggable: "true",
                        onDragstart: (e) => dragStart(e, cat2),
                        onDragend: dragEnd
                      }, _toDisplayString(cat2.title), 41, _hoisted_6)
                    ]))
                  }), 128))
                ])
              ]))
            }), 128)),
            (drag.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                  _createElementVNode("div", {
                    class: "drop-target",
                    onDrop: _cache[2] || (_cache[2] = (e) => dragDrop(e, null)),
                    onDragover: _cache[3] || (_cache[3] = (e) => dragOver(e)),
                    onDragleave: _cache[4] || (_cache[4] = (e) => dragLeave(e))
                  }, null, 32)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _cache[8] || (_cache[8] = _createElementVNode("h2", null, "Sort CO2 Questions", -1)),
      _createVNode(_component_v_alert, { type: "info" }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("Sort the items in the order of which the questions will be presented.")
        ])),
        _: 1
      }),
      _createVNode(SortItems, {
        items: [...props.data],
        onChange: save
      }, null, 8, ["items"])
    ]),
    _: 1
  }))
}
}

})